import { Route, Routes, Navigate } from "react-router-dom";
import { AffiliateDashboard } from "../pages/affiliate/Dashboard";
import { ActiveBrands } from "../pages/affiliate/ActiveBrands";
import { SearchBrand } from "../pages/affiliate/SearchBrand";
import { Payout } from "../pages/affiliate/Payout";
import { default as PayoutHistory } from "../pages/affiliate/PayoutHistory";
import { default as Settings } from "../pages/affiliate/Settings/Settings";
import { BrandDetailView } from "../pages/affiliate/BrandDetails";
import { ProgramProvider } from "../contexts/program";
import AffiliateContentProgramsLayout from "../pages/affiliate/content-programs/AffiliateContentProgramsLayout";
import AffiliateContentProgramsList from "../pages/affiliate/content-programs/ContentProgramsList";
import AffiliateSubmitContent from "../pages/affiliate/content-programs/SubmitContent";
import AffiliateMySubmissions from "../pages/affiliate/content-programs/MySubmissions";
import { SignUp } from "../pages/affiliate/auth/SignUp";
import { GoogleComplete } from "../pages/affiliate/auth/GoogleComplete";
import PayoutDetail from "../pages/affiliate/PayoutDetail";
import { NotFound } from "../pages/NotFound";
import { AffiliateProtectedRoute } from "../components/auth/AffiliateProtectedRoute";
import {
  CrossBrandRoute,
  MarketplaceRoute,
} from "../components/auth/MarketplaceRoute";
import { PortalBrandRoute } from "../components/auth/PortalBrandRoute";
import { ActiveBrandsRoute } from "../components/auth/ActiveBrandsRoute";
import { AffiliateLayout } from "../layouts/affiliate/AffiliateLayout";
import { EmailConfirmation } from "../pages/affiliate/auth/EmailConfirmation";
import { Invitations } from "../pages/affiliate/Invitations";
import { Notifications } from "../pages/affiliate/Notifications";
import VerifyOTP from "@/pages/affiliate/auth/VerifyOTP";
import ResetPassword from "@/pages/affiliate/auth/ResetPassword";
import ForgotPassword from "@/pages/affiliate/auth/ForgotPassword";
import { AuthProvider } from "../contexts/AuthContext/provider";
import { AuthLayout as AffiliateAuthLayout } from "@/layouts/affiliate/AuthLayout";
import { AuthLayout } from "@/pages/auth/Layout";
import Faq from "@/pages/Faq";
import { ResourceSharing } from "@/components/affiliate/ResourceSharing";
import RewardsLanding from "@/components/common/rewardLanding";
import PublicRewardProfile from "@/pages/PublicRewardProfile";
import { Support } from "@/pages/brand/support/Support";
import AffiliateProgramPage from "@/pages/affiliate/ProgramPage";

export function AffiliateRoutes() {
  return (
    <AuthProvider>
      <ProgramProvider>
        <Routes>
          {/* Auth Routes */}
          <Route
            path="auth"
            element={<AuthLayout navState="small-screen-hide" />}
          >
            <Route path="signup" element={<SignUp />} />
            <Route path="google/complete" element={<GoogleComplete />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="verify-otp" element={<VerifyOTP />} />
          </Route>
          <Route path="auth" element={<AffiliateAuthLayout />}>
            <Route index element={<Navigate to="login" replace />} />
            {/* Email confirmation is now optional */}
            <Route path="email-confirmation" element={<EmailConfirmation />} />
          </Route>

          {/* Public Routes - No authentication required */}
          <Route
            path="rewards/public/:token"
            element={<PublicRewardProfile />}
          />

          {/* Protected Routes */}
          <Route
            element={
              <AffiliateProtectedRoute>
                <AffiliateLayout />
              </AffiliateProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AffiliateDashboard />} />

            {/* Brands Routes */}
            <Route path="brands">
              <Route
                index
                element={
                  <ActiveBrandsRoute>
                    <ActiveBrands />
                  </ActiveBrandsRoute>
                }
              />
              <Route
                path="search"
                element={
                  <MarketplaceRoute>
                    <SearchBrand />
                  </MarketplaceRoute>
                }
              />
              <Route
                path=":username"
                element={
                  <PortalBrandRoute>
                    <BrandDetailView />
                  </PortalBrandRoute>
                }
              />
            </Route>

            {/* Content programs */}
            <Route path="content-programs">
              <Route element={<AffiliateContentProgramsLayout />}>
                <Route index element={<AffiliateContentProgramsList />} />
                <Route
                  path="submissions"
                  element={<AffiliateMySubmissions />}
                />
              </Route>
              <Route
                path=":programId/submit"
                element={<AffiliateSubmitContent />}
              />
            </Route>

            {/* A brand's tier program page. The API enforces portal scope
                and membership, so no route guard is needed here. */}
            <Route path="program/:username" element={<AffiliateProgramPage />} />

            {/* Brand Resources Routes */}
            <Route path="brand-resources" element={<ResourceSharing />} />
            <Route
              path="rewards"
              element={
                <CrossBrandRoute>
                  <RewardsLanding />
                </CrossBrandRoute>
              }
            />

            {/* Payout Routes */}
            <Route path="payouts">
              <Route index element={<Payout />} />
              <Route path="history" element={<PayoutHistory />} />
              <Route path="history/:payoutId" element={<PayoutDetail />} />
            </Route>

            {/* Settings */}
            <Route path="settings" element={<Settings />} />

            {/* Invitations */}
            <Route path="invitations" element={<Invitations />} />

            {/* Faq */}
            <Route path="faq" element={<Faq />} />
      
            <Route path="support" element={<Support />} />

            {/* Notifications */}
            <Route path="notifications" element={<Notifications />} />

            <Route path="*" element={<NotFound />} />
          </Route>
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ProgramProvider>
    </AuthProvider>
  );
}
